module.exports = __webpack_public_path__ + "img/bj.8e235e45.png";